import { useLocation } from 'react-router-dom';

// we want to find the query string and convert it to an object
export const useQueryStringToObject = <T extends Record<string, any>>(): T => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const params = Object.fromEntries(searchParams.entries()) as T;
  return params;
};
